/// <reference path="../system/jquery-1.11.3.min.js" />
/// <reference path="Helper.DOM.js" />
/// <reference path="Helper.Url.js" />
/// <reference path="Helper.String.js" />
/// <reference path="Helper.Image.js" />

window.Helper = window.Helper || {};

/**
 * @param name {string}
 * @return {string}
 */
window.Helper.getMetadata = (name) => window.Helper.DOM.getMetadata(name);

/**
 * @param url {string}
 * @return {string}
 */
window.Helper.resolveUrl = (url) => window.Helper.Url.resolveUrl(url);

/**
 * @param alienString {string}
 * @param defaultString {?string}
 * @param language {?string}
 */
window.Helper.getTranslatedString = (alienString, defaultString = null, language = null) =>
	window.Helper.String.getTranslatedString(alienString, defaultString, language),

	/**
	 * @param longString {string}
	 * @param maxLength {number}
	 */
	window.Helper.limitStringWithEllipses = (longString, maxLength = undefined) =>
		window.Helper.String.limitStringWithEllipses(longString, maxLength),

	/**
	 * @param obj {*}
	 * @returns {string}
	 */
	window.Helper.objectToString = (obj) => window.Helper.Object.objectToString(obj);


/**
 * @param unsafeText
 * @returns {string}
 */
window.Helper.htmlEntities = (unsafeText) => window.Helper.String.htmlEntities(unsafeText);

window.Helper.mousePosition = {X: 0, Y: 0};

window.Helper.log = (...params) => console?.log(...params);

/**
 * @param element {JQuery}
 * @param unblock {boolean}
 */
window.Helper.blockElement = (element, unblock = false) => window.Helper.DOM.blockElement(element, unblock);

/**
 * @param element {HTMLElement}
 * @param removeClass {string}
 */
window.Helper.createLink = (element, removeClass) => {
	window.Helper.DOM.createLink(element, removeClass);
};

/** @returns {string} */
window.Helper.generateGuid = () => {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = Math.random() * 16 | 0;
		const v = c === "x" ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
};

$(document).mousemove(function (e) {
	window.Helper.mousePosition.X = e.pageX;
	window.Helper.mousePosition.Y = e.pageY;
});

